import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ChronologyListItem from './ChronologyListItem';
import ChronologyDetails from './details/ChronologyDetails';

import buttons from './ChronologyButtons';
import events from './ChronologyEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('chronology'),
	routes: [
		{
			path: 'chronology/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'chronology'),
			element: (
				<DetailsPage
					key="chronology/add"
					module="chronology"
					tabs={ChronologyDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'chronology/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'chronology'),
			element: (
				<DetailsPage
					key="chronology/details"
					module="chronology"
					tabs={ChronologyDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'chronology/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'chronology'),
			element: (
				<ViewPage
					key="chronology/view"
					module="chronology"
					content={{ type: 'list', itemLayout: ChronologyListItem, id: 'chronologyView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
